import { baseURL } from "@/utils/url";

export const Internal_Token = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "internaltoken", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const mobileOtpVerification = async (otp, mobile, body) => {
    try {
        const fetchResponse = await fetch(`${baseURL}mobileOtpVerification?otp=${otp}&mobile=${mobile}`, {
            method: "POST",
            headers: {
                Authorization: "",
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const generateMobileOtp = async (body) => {
    try {
        const fetchResponse = await fetch(`${baseURL}generateMobileOtp`, {
            method: "POST",
            headers: {
                Authorization: "",
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getCustomers = async (token, body) => {
    try {
        const fetchResponse = await fetch(baseURL + `getCustomerData`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
              body: JSON.stringify(body),
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};
export const updateCustomers = async (token, customerCode, data) => {
    try {
        const fetchResponse = await fetch(baseURL + `updateCustomer?customerCode=${customerCode}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const response = await fetchResponse.json();
        return response;
    } catch (error) {
        return error;
    }
};
export const signUpCustomer = async (token, data) => {
    try {
        const fetchResponse = await fetch(baseURL + "customerRegistration", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const response = await fetchResponse.json();
        return response;
    } catch (error) {
        return error;
    }
};


export const updateQr = async (token,id,body,slogan) => {
    try {
        const fetchResponse = await fetch(`${baseURL}updateSlogan?id=${id}&type=Customers&slogan=${slogan}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
               body: JSON.stringify(body),
        });
        return await fetchResponse;
    } catch (error) {
        return error;
    }
};